import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {Button, Input, Label} from 'reactstrap';
import autobind from 'autobind-decorator';
import {createTrainingTemplate, loadTrainingTemplates, selectTrainingTemplate} from 'training/actions';
import Dialog from 'apa/containers/Dialog';

@connect(
    null,
    dispatch => ({
        load: () => dispatch(loadTrainingTemplates()),
        create: (template) => dispatch(createTrainingTemplate(template)),
        select: (template) => dispatch(selectTrainingTemplate(template)),
    }))
export default class NewTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            name: '',
        };
    }

    @autobind
    toggle() {
        this.setState({isOpen: !this.state.isOpen});
    }

    @autobind
    confirm() {
        this.props.create({name: this.state.name, data: {}})
        this.toggle()
    }

    render() {
        return (
            <Fragment>
                <Button color='primary' onClick={this.toggle}>Neuen Fragenkatalog anlegen</Button>
                <Dialog isOpen={this.state.isOpen} toggle={this.toggle} confirm={this.confirm}
                        title="Neuen Fragenkatalog anlegen">
                    <Label>
                        Name
                    </Label>
                    <Input type="text" value={this.state.name}
                           onChange={e => this.setState({name: e.target.value})}/>
                </Dialog>
            </Fragment>);
    }
}
